export default "__VITE_ASSET__CQVO6lWB__"